import React from 'react';
import styles from './Services.module.css';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: 'fas fa-hotel',
      title: 'Гостиничные чеки',
      description: 'Официальные чеки с QR-кодом от гостиниц Москвы. Подтверждение через ФНС. Работаем с любыми сетями отелей.',
      features: ['QR-код ФНС', 'Подтверждение онлайн', 'Любые суммы', 'Срочное изготовление']
    },
    {
      id: 2,
      icon: 'fas fa-building',
      title: 'Строительные материалы',
      description: 'Чеки за строительные материалы и оборудование. Товарные чеки, накладные, счета-фактуры.',
      features: ['Товарные чеки', 'Накладные', 'Счет-фактуры', 'Все строительные магазины']
    },
    {
      id: 3,
      icon: 'fas fa-file-invoice-dollar',
      title: 'Бухгалтерские документы',
      description: 'Полный пакет документов для отчетности: УПД, акты выполненных работ, счета на оплату.',
      features: ['УПД', 'Акты работ', 'Счета на оплату', 'Электронный документооборот']
    },
    {
      id: 4,
      icon: 'fas fa-car',
      title: 'Автомобильные услуги',
      description: 'Чеки за автосервис, запчасти, бензин. Все необходимые документы для командировочных.',
      features: ['Автосервис', 'Запчасти', 'Топливо', 'СТО']
    },
    {
      id: 5,
      icon: 'fas fa-shopping-cart',
      title: 'Торговые сети',
      description: 'Чеки из любых торговых сетей Москвы: продукты, техника, одежда, строительные материалы.',
      features: ['Все сети', 'Продукты', 'Техника', 'Одежда']
    },
    {
      id: 6,
      icon: 'fas fa-shield-alt',
      title: 'Конфиденциальность',
      description: 'Полная анонимность и безопасность. Никаких данных в открытом доступе.',
      features: ['Анонимность', 'Шифрование', 'Безопасность', 'Конфиденциальность']
    }
  ];

  return (
    <section id="services" className={`section ${styles.services}`}>
      <div className="container">
        <div className={styles.servicesHeader}>
          <h2 className="section-title">
            НАШИ <span className="section-title--accent">УСЛУГИ</span>
          </h2>
          <p className="section-subtitle">
            Мы предоставляем официальные кассовые чеки с 100% подтверждением 
            через ФНС для всех видов отчетности
          </p>
        </div>

        <div className={styles.servicesGrid}>
          {services.map(service => (
            <div key={service.id} className={`card ${styles.serviceCard}`}>
              <div className={styles.serviceIcon}>
                <i className={service.icon}></i>
              </div>
              <h3 className={styles.serviceTitle}>{service.title}</h3>
              <p className={styles.serviceDescription}>{service.description}</p>
              <ul className={styles.serviceFeatures}>
                {service.features.map((feature, index) => (
                  <li key={index} className={styles.serviceFeature}>
                    <i className="fas fa-check-circle"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              <a href="#contact" className={`btn btn--outline ${styles.serviceButton}`}>
                Заказать
                <i className="fas fa-arrow-right"></i>
              </a>
            </div>
          ))}
        </div>

        <div className={styles.servicesFooter}>
          <div className={styles.guarantee}>
            <div className={styles.guaranteeIcon}>
              <i className="fas fa-shield-check"></i>
            </div>
            <div className={styles.guaranteeContent}>
              <h3 className={styles.guaranteeTitle}>Гарантии качества</h3>
              <p className={styles.guaranteeText}>
                Все чеки проходят проверку через ФНС и имеют 100% подтверждение. 
                Мы гарантируем конфиденциальность и безопасность всех операций.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;